import useSocialMedia from './useSocialMedia';

export default useSocialMedia;
